import React from "react";
import { makeStyles } from "@mui/styles";
import ArtistSubmissionButton from "../Buttons/ArtistSubmission";
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    fontFamily: "'Inter', sans-serif",
    display: "flex",
    justifyContent: "flex-start",
    color: "white",
    position: "relative",
    overflow: "hidden",
    padding:"0 15px",
    marginBottom:"120px",
    '@media(max-width:480px)':{
      marginBottom:"40px",
    },
  },
  info: {
    position:"relative",
    width: "100%",
    maxWidth:"1280px",
    display: "flex",
    alignItems:"center",
    background:"right/1280px auto no-repeat url(/images/artistsubmission/bg-mike.png)",
    minHeight:"415px",
    borderRadius:"30px",
    margin:"auto",
    '@media(max-width:480px)':{
      alignItems:"start",
      paddingTop:"24px",
      paddingLeft:"24px",
      minHeight:"345px",
      background:"right/100% 100% no-repeat url(/images/artistsubmission/bg-mike-mobile.png)",
    },
  },
  infoDetails: {
    width: "100%",
    maxWidth:"675px",
    position:"relative",
    zIndex:"1",
    paddingLeft:"43px",
    '@media(max-width:480px)':{
      padding:"0",
    }
  },

  artistName: {
    margin: "0",
    fontSize: "42px",
    fontWeight: "700",
    fontStyle: "normal",
    fontFamily: "Inter",
    lineHeight: "44px",
    [theme.breakpoints.down("sm")]: {
      padding: '0px 20px',
      fontWeight: 600,
      fontSize: '24px',
      lineheight: '29px',
    },
    '@media(max-width:480px)':{
      fontSize: "24px",
      fontWeight: "600",
    },
  },
  artistDesc: {
    fontSize: "20px",
    fontWeight: "400",
    fontStyle: "normal",
    fontFamily: "Inter",
    lineHeight: "34px",
    marginTop: "30px",
    marginBottom: "45px",
    [theme.breakpoints.down("sm")]: {
      padding: '0px 20px',
      fontSize: '16px',
      lineheight: '24px',
    },
    '@media(max-width:480px)':{
      fontSize: "14px",
      lineHeight: "24px",
      marginTop: "16px",
      marginBottom: "36px",
    },
  },
  image: {
    position: "absolute",
    height: "650px",
    right: "0",
    bottom: "-230px",
    zIndex:"0",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
    '@media(max-width:480px)':{
      right:"50%",
      transform:"translateX(58%)",
      height: "auto",
      bottom:"-155px"
    },
  },
}));

export default function ArtistSubmission(data) {
  const areyouartisttitle = data.data.get("areyouartisttitle");
  const areyouartisdesc = data.data.get("areyouartisdesc");

  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.info}>
        <div className={classes.infoDetails}>
          <h2 className={classes.artistName}>{areyouartisttitle}</h2>
          <p className={classes.artistDesc}>{areyouartisdesc}</p>
          <ArtistSubmissionButton />
        </div>
      </div>
      {/* <img className={classes.image} src="/images/home/bottom-section-bg.png" /> */}
    </div>
  );
}
